var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"size":"mini"},on:{"change":function($event){return _vm.changeStatus()}},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},_vm._l((_vm.formatData.statuses),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.title,"value":+item.id,"disabled":_vm.disabled}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }